module.exports = __webpack_public_path__ + "1.4.15-unryo/img/microsoft-azure.ab957f50.svg";